<template>
  <div class="launch-notice md-layout text-center">
    <div class="md-layout-item md-size-100" />
    <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100 launch-card-wrap">
      <div class="launch-card">
        <h2 class="launch-title">Chuyển sang trang Chat mới</h2>
        <p class="launch-lead">
          Hệ thống chat đã chuyển theo từng khu vực. Vui lòng dùng đúng địa chỉ dưới đây để làm việc hàng ngày.
        </p>
        <p v-if="!hasUrl" class="launch-warn">
          Không xác định được địa chỉ chat cho tài khoản của bạn. Liên hệ quản trị viên hoặc bộ phận IT để được cấp link đúng.
        </p>
        <div v-else class="launch-actions">
          <a
            :href="canonicalUrl"
            class="launch-btn"
            rel="noopener noreferrer"
          >
            Mở trang Chat
          </a>
          <p class="launch-hint">Sau khi mở, hãy đăng nhập lại trên trang mới (phiên hiện tại chỉ dùng để thông báo).</p>
        </div>
        <p v-if="canonicalUrl" class="launch-url">{{ canonicalUrl }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatDomainLaunch",

  computed: {
    notice() {
      return this.$store.state.auth.chatLaunchNotice;
    },
    canonicalUrl() {
      const u = this.notice && this.notice.canonical_chat_social_url;
      return u && String(u).trim() ? String(u).trim() : "";
    },
    hasUrl() {
      return this.canonicalUrl.length > 0;
    },
  },

  mounted() {
    if (!this.notice || !this.notice.show) {
      this.$router.replace({ name: "New Feeds" });
    }
  },
};
</script>

<style scoped>
.launch-notice {
  min-height: 60vh;
  align-items: center;
}
.launch-card-wrap {
  margin: 0 auto;
}
.launch-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  padding: 2rem 1.75rem;
  text-align: left;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
}
.launch-title {
  margin: 0 0 0.75rem;
  font-size: 1.35rem;
  font-weight: 700;
  color: #1e293b;
}
.launch-lead {
  margin: 0 0 1rem;
  font-size: 0.95rem;
  line-height: 1.55;
  color: #475569;
}
.launch-warn {
  margin: 0;
  padding: 0.75rem 1rem;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 8px;
  color: #9a3412;
  font-size: 0.875rem;
}
.launch-actions {
  margin-top: 0.5rem;
}
.launch-btn {
  display: inline-block;
  margin-top: 0.5rem;
  padding: 0.65rem 1.25rem;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  color: #fff !important;
  text-decoration: none !important;
  background: linear-gradient(90deg, #f59e0b, #ea580c);
  box-shadow: 0 8px 20px rgba(234, 88, 12, 0.25);
}
.launch-btn:hover {
  filter: brightness(1.05);
}
.launch-hint {
  margin: 1rem 0 0;
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.45;
}
.launch-url {
  margin: 1.25rem 0 0;
  font-size: 0.75rem;
  word-break: break-all;
  color: #94a3b8;
}
</style>
